/*
 * QRCodeImage
 * @module components
 * @flow
 */

// $FlowIssue
import React, { forwardRef } from 'react';
import styled from 'styled-components/macro';
import Code from 'qrcode.react';

import { Block } from '~/components/Block';

export type QRCodeImageProps = {
  value: string,
  palette?: string,
  renderAs?: 'svg' | 'canvas',
};

const QRCodeImageWrapper = styled(Block).attrs(() => ({
  elevation: 2,
}))`
  padding: 10px;
`;

/**
 * QRCodeImage React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {string} [props.value] - string to encode
 * @param {string} [props.palette = 'primary'] - current QR Code palette
 * @example <caption>Simple usage</caption>
 * <QRCodeImage value="http://facebook.github.io/react" />
 * @returns {React.Node<*>} React-component
 */
export const QRCodeImage = forwardRef(
  ({ value, renderAs, ...rest }: QRCodeImageProps, ref) => (
    <QRCodeImageWrapper {...rest} rounded={false} testid="qrcodeimage">
      <Code
        size={140}
        renderAs={renderAs}
        fgColor="currentcolor"
        value={value || ''}
        ref={ref}
      />
    </QRCodeImageWrapper>
  ),
);

QRCodeImage.defaultProps = {
  palette: 'grayscale',
  renderAs: 'svg',
};
